import { createAction } from 'redux-actions';
import { ModalType } from '../../Modals/redux/types';
import { pushModal } from '../../Modals/redux/basicActions';
export const reduxKey = '@@DeviationGroupList';
export const showDeviationGroupListPopup = (params)=>pushModal(ModalType.DEVIATION_GROUP_LIST, {
        params
    });
export const getStreamId = (deviationId)=>`featuredInGroups-${deviationId}`;
export const initializeStreamAndFetchFirst = createAction(`${reduxKey}/INITIALIZE`, (deviationId)=>({
        deviationId
    }));
export const fetchNext = createAction(`${reduxKey}/FETCH_NEXT`, (streamId)=>({
        streamId
    }));
export const removeDeviationFromGroup = createAction(`${reduxKey}.REMOVE_DEVIATION_FROM_GROUP`, (payload)=>payload);
export const removeDeviationFromGroupSuccess = createAction(`${reduxKey}.REMOVE_DEVIATION_FROM_GROUP_SUCCESS`, (payload)=>payload);
